module.exports = __webpack_public_path__ + "assets/img/list-1.85ac2b77.png";